// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.template-page {
  padding: 20px;
  background: #f5f5f5;
}

/* Header */

.template-header {
  background: white;
  border: 1px solid #ccc;
  padding: 10px;
  margin-bottom: 20px;
}

.header-row {
  display: flex;
  border-bottom: 1px solid #ddd;
}

.header-label {
  width: 180px;
  font-weight: 600;
  padding: 8px;
  background: #f3f3f3;
}

.header-value {
  padding: 8px;
}

/* Table */

.preview-table {
  margin-top: 10px;
}

.preview-box {
  width: 300px;
  display: flex;
  justify-content: center;
}

.preview-image {
  width: 200px;
  border: 1px solid #ccc;
}

/* Create Tag Form */

.create-tag {
  margin-top: 30px;
  background: white;
  padding: 20px;
  border: 1px solid #ccc;
}

.create-tag input {
  padding: 8px;
  margin-right: 10px;
}

.create-tag button {
  padding: 8px 16px;
  background: #1976d2;
  border: none;
  color: white;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/components/pages/ai-management/create-tag/CreateTag.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA,WAAW;;AAEX;EACE,iBAAiB;EACjB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA,UAAU;;AAEV;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,sBAAsB;AACxB;;AAEA,oBAAoB;;AAEpB;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,eAAe;AACjB","sourcesContent":[".template-page {\n  padding: 20px;\n  background: #f5f5f5;\n}\n\n/* Header */\n\n.template-header {\n  background: white;\n  border: 1px solid #ccc;\n  padding: 10px;\n  margin-bottom: 20px;\n}\n\n.header-row {\n  display: flex;\n  border-bottom: 1px solid #ddd;\n}\n\n.header-label {\n  width: 180px;\n  font-weight: 600;\n  padding: 8px;\n  background: #f3f3f3;\n}\n\n.header-value {\n  padding: 8px;\n}\n\n/* Table */\n\n.preview-table {\n  margin-top: 10px;\n}\n\n.preview-box {\n  width: 300px;\n  display: flex;\n  justify-content: center;\n}\n\n.preview-image {\n  width: 200px;\n  border: 1px solid #ccc;\n}\n\n/* Create Tag Form */\n\n.create-tag {\n  margin-top: 30px;\n  background: white;\n  padding: 20px;\n  border: 1px solid #ccc;\n}\n\n.create-tag input {\n  padding: 8px;\n  margin-right: 10px;\n}\n\n.create-tag button {\n  padding: 8px 16px;\n  background: #1976d2;\n  border: none;\n  color: white;\n  cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
